import { Injectable, signal } from '@angular/core';
import { Observable, delay, of, tap } from 'rxjs';
import { SignInRequest, RegisterRequest } from './requests/auth.requests';
import { UserResponse } from './responses/auth.responses';

const SESSION_KEY = 'cf-session';

// Mock auth: any credentials are accepted and a fake session is persisted.
// When the API is ready, replace the method bodies with real HTTP calls.
@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly currentUser = signal<UserResponse | null>(this.readSession());

  signIn(request: SignInRequest): Observable<UserResponse> {
    const user: UserResponse = {
      id: crypto.randomUUID(),
      username: request.email.split('@')[0] || 'slayer',
      email: request.email,
      avatarUrl: 'assets/avatars/avatar1.svg',
      status: 'online'
    };
    return of(user).pipe(delay(400), tap(u => this.startSession(u)));
  }

  register(request: RegisterRequest): Observable<UserResponse> {
    const user: UserResponse = {
      id: crypto.randomUUID(),
      username: request.username || request.email.split('@')[0] || 'slayer',
      email: request.email,
      avatarUrl: 'assets/avatars/avatar1.svg',
      status: 'online'
    };
    return of(user).pipe(delay(400), tap(u => this.startSession(u)));
  }

  signOut(): void {
    localStorage.removeItem(SESSION_KEY);
    this.currentUser.set(null);
  }

  private startSession(user: UserResponse): void {
    localStorage.setItem(SESSION_KEY, JSON.stringify(user));
    this.currentUser.set(user);
  }

  private readSession(): UserResponse | null {
    try {
      return JSON.parse(localStorage.getItem(SESSION_KEY) ?? 'null');
    } catch {
      return null;
    }
  }
}
